<template>
    <div>
        <h1>{{status}} Error</h1>
        <p>{{reason}}</p>
        <p>{{msg}}</p>
        <router-link to="/" exact>
            Go to home page
        </router-link>
    </div>
</template>

<script>
export default {
  data() {
    return {
      status: 404,
      reason: "Page not found",
      msg: ""
    }
  },
  created() {
    this.status = this.$route.query.status || this.status
    this.reason = this.$route.query.reason || this.reason
    this.msg = this.$route.query.msg || this.msg
  }
}
</script>
